import {
    DROPBOXES__REQUESTED,
} from '../constants/actionTypes';

export function requestDropboxes (store) {
    store.dispatch({
        type: DROPBOXES__REQUESTED
    });
}


/** WEBPACK FOOTER **
 ** ./src/routes/route_callbacks.js
 **/